import React, { useState, useEffect } from "react";
import { notesAPI } from "../services/api";

const NoteModal = ({ note, customerId, onClose }) => {
  const [formData, setFormData] = useState({ note: "" });
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");

  useEffect(() => {
    if (note) setFormData({ note: note.note || "" });
  }, [note]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = { ...formData, customer_id: customerId };
      if (note) {
        await notesAPI.update(note.id, data);
      } else {
        await notesAPI.create(data);
      }
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to save note");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6">
      {/* Backdrop */}
      <div className="fixed inset-0 bg-gray-900 bg-opacity-50" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto">
        <form onSubmit={handleSubmit}>
          {/* Header */}
          <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 sticky top-0 bg-white z-10">
            <h3 className="text-lg font-semibold text-gray-900">
              {note ? "Edit Note" : "Add New Note"}
            </h3>
            <button
              type="button"
              onClick={onClose}
              className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="px-5 py-5">
            {error && (
              <div className="mb-4 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div>
              <label htmlFor="note" className="form-label">Note *</label>
              <textarea
                id="note"
                name="note"
                rows={6}
                required
                className="form-textarea"
                placeholder="Enter your note about this customer..."
                value={formData.note}
                onChange={e => setFormData({ note: e.target.value })}
                disabled={loading}
              />
              <p className="mt-2 text-xs text-gray-500">
                Add important information, reminders, or observations about this customer.
              </p>
            </div>
          </div>

          {/* Footer */}
          <div className="px-5 py-4 bg-gray-50 rounded-b-xl flex flex-col sm:flex-row-reverse gap-3">
            <button
              type="submit"
              disabled={loading}
              className="btn btn-primary w-full sm:w-auto"
            >
              {loading ? (
                <span className="flex items-center justify-center gap-2">
                  <span className="loading-spinner" /> Saving...
                </span>
              ) : note ? "Update Note" : "Add Note"}
            </button>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="btn btn-secondary w-full sm:w-auto"
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default NoteModal;
